// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"88e181b5","254":"ec13d786","508":"88e181b5","549":"88e181b5","593":"88e181b5","699":"88e181b5","947":"88e181b5"}[chunkId] + ".chunk.css";
};